export default {
    deviceManagement: 'Device Management',
    searchByBureau: 'Search by Bureau',
    search: 'Search',
    edit: 'Edit',
    bureau: 'Bureau',
    acronym: 'Acronym',
    organization: 'Organization',
    locationAccess: 'Location Access',
    totalEmployee: 'Total Employee',
    action: 'Action',
    allOrganization: 'All Organization'
}
